import React from "react";
import { AnimateFrame } from "../../components/AnimateFrame";
import { Header } from "../../components/Header";
import { Servicos } from "../../components/Servicos";
import { Container } from "../../style/GlobalStyle";

export const Services = () => {
  return (
    <Container>
      <Header />
      <AnimateFrame>
        <Servicos />
      </AnimateFrame>
    </Container>
  );
};
